// La URL de la API la pone cada ambiente al compilar, en REACT_APP_API_URL:
// deploy.sh compila con la de producción y deploy-test.sh con la de pruebas, y
// cada uno verifica dentro del bundle que quedó la correcta. En local, npm start
// la toma de .env.development, que apunta a pruebas; para usar otra (el backend
// local, por ejemplo) se crea .env.development.local, que no se versiona.
//
// No lleva valor por defecto a propósito: si faltara la variable, un build
// saldría contra la API que estuviera escrita aquí, sin avisar.
export const urlApi = process.env.REACT_APP_API_URL;
//export const nitOsviel = "8921200207";
export const nitOsviel = "900344946";
